import React, { useState, useEffect, useRef } from "react";
import "./Gallery.css";

const PUBLIC = process.env.PUBLIC_URL || "";

// Put the images under public/{tgpEvents,gallery}/...
const featureImages = {
    feature1: [
        { src: `${PUBLIC}/tgpEvents/BloodDonation2026.jpg`, caption: "BloodDonation 2026" },
        { src: `${PUBLIC}/tgpEvents/BloodDonation2025.jpg`, caption: "BloodDonation 2025" },
        { src: `${PUBLIC}/tgpEvents/BloodDonation2024.jpg`, caption: "BloodDonation 2024" },
        { src: `${PUBLIC}/tgpEvents/BloodDonation.jpeg`, caption: "BloodDonation 2023" },
        { src: `${PUBLIC}/tgpEvents/BloodDanation2.jpeg`, caption: "Blood Donation" },
    ],
    feature2: [
        { src: `${PUBLIC}/tgpEvents/HWCleanup2026.jpeg`, caption: "Highway Drive Cleanup 2026" },
        { src: `${PUBLIC}/tgpEvents/HWCleanup2025.jpg`, caption: "Highway Drive Cleanup 2025" },
        { src: `${PUBLIC}/tgpEvents/HWCleanup2024.jpg`, caption: "Highway Drive Cleanup 2024" },
        { src: `${PUBLIC}/tgpEvents/HWCleanup2023.jpg`, caption: "Highway Drive Cleanup 2023" },
        { src: `${PUBLIC}/tgpEvents/HwCleanup2020.jpeg`, caption: "Highway Drive Cleanup" },
    ],
    feature3: [
        { src: `${PUBLIC}/tgpEvents/FoodBank25.jpeg`, caption: "FoodBank Volunteer 2025" },
        { src: `${PUBLIC}/tgpEvents/CanmoreVolunteer.jpg`, caption: "Canmore Event Volunteer" },
        { src: `${PUBLIC}/tgpEvents/LethBridgeVolunteer.jpg`, caption: "LethBridge Event Volunteer" },
        { src: `${PUBLIC}/tgpEvents/ConcertVolunteer.jpeg`, caption: "Calgary Event Volunteer" },
        { src: `${PUBLIC}/tgpEvents/FoodDriveVolunteer.jpg`, caption: "Calgary Food Drive Volunteer" },
    ],
    feature4: [
        { src: `${PUBLIC}/tgpEvents/TGP12.jpg`, caption: "2026 1st General Assembly" },
        { src: `${PUBLIC}/tgpEvents/TGP9.jpg`, caption: "57th TGP Anniversary" },
        { src: `${PUBLIC}/tgpEvents/TGP5.jpeg`, caption: "A Family in Brotherhood & Sisterhood together" },
        { src: `${PUBLIC}/tgpEvents/TGP4.jpeg`, caption: "A Family in Brotherhood & Sisterhood together" },
        { src: `${PUBLIC}/tgpEvents/TGP3.jpeg`, caption: "A Family in Brotherhood & Sisterhood together" },
        { src: `${PUBLIC}/tgpEvents/TGP1.jpeg`, caption: "A Family in Brotherhood & Sisterhood together" },
        { src: `${PUBLIC}/tgpEvents/TGP6.jpeg`, caption: "A Family in Brotherhood & Sisterhood together" },
        { src: `${PUBLIC}/tgpEvents/TGP7.jpg`, caption: "A Family in Brotherhood & Sisterhood together" },
    ],
    feature5: [
        { src: `${PUBLIC}/tgpEvents/Fam7.jpeg`, caption: "SARC Camping @026" },
        { src: `${PUBLIC}/tgpEvents/Fam6.jpg`, caption: "General Assembly with Family" },
        { src: `${PUBLIC}/tgpEvents/Fam5.jpg`, caption: "SARC 2025 Christmas and  Year End Party" },
        { src: `${PUBLIC}/tgpEvents/Fam4.jpg`, caption: "Another great event" },
        { src: `${PUBLIC}/tgpEvents/Fam3.jpeg`, caption: "Community partnership" },
        { src: `${PUBLIC}/tgpEvents/Fam2.jpeg`, caption: "Growth and success" },
        { src: `${PUBLIC}/tgpEvents/Fam1.jpeg`, caption: "Celebrating together" },
    ],
};

const heroSlides = [
    {
        src: `${PUBLIC}/tgpEvents/58thAnniv.jpeg`,
        title: "58th Founding Anniversary of Tau Gamma Phi",
        text: "United in brotherhood and sisterhood under one banner - the Southern Alberta Regional Council.",
    },
    {
        src: `${PUBLIC}/tgpEvents/57thAnniv.JPG`,
        title: "57th Founding Anniversary of Tau Gamma Phi",
        text: "United in brotherhood and sisterhood under one banner - the Southern Alberta Regional Council.",
    },
    {
        src: `${PUBLIC}/tgpEvents/TGPAniv.jpg`,
        title: "20 Years of Brotherhood",
        text: "Two decades of unbreakable bonds, service, and Triskelion pride.",
    },
    {
        src: `${PUBLIC}/tgpEvents/HWCleanup2023.jpg`,
        title: "Highway Cleanup Drive",
        text: "Southern Alberta Triskelions in action, proudly serving and keeping our roads clean.",
    },
    {
        src: `${PUBLIC}/tgpEvents/TGPOct4Aniv.jpg`,
        title: "Bound by Purpose",
        text: "Celebrating strength, loyalty, and the spirit of service.",
    },
    {
        src: `${PUBLIC}/tgpEvents/2ndGeneralMeeting.jpg`,
        title: "General Meeting & Easter Bonding",
        text: "Brotherhood, unity, and community together as one Triskelion family.",
    },
];

// a small helper to swap in a placeholder if an image 404s
const fallback = (e, n) => {
    e.currentTarget.src = `https://picsum.photos/1200/540?random=${n}`;
    e.currentTarget.onerror = null;
};

export default function Gallery() {
    const [showModal, setShowModal] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeHero, setActiveHero] = useState(0);
    const rowsRef = useRef([]);

    const openModal = (images, startIndex = 0) => {
        setSelectedImages(images);
        setCurrentIndex(startIndex);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedImages([]);
        setCurrentIndex(0);
    };

    const showPrevHero = () => {
        setActiveHero((i) => (i - 1 + heroSlides.length) % heroSlides.length);
    };

    const showNextHero = () => {
        setActiveHero((i) => (i + 1) % heroSlides.length);
    };

    const getHeroPosition = (index) => {
        const total = heroSlides.length;
        const diff = (index - activeHero + total) % total;
        if (diff === 0) return "active";
        if (diff === 1) return "next";
        if (diff === 2) return "far-next";
        if (diff === total - 1) return "prev";
        return "far-prev";
    };

    // Keyboard navigation
    useEffect(() => {
        if (!showModal) return;
        const onKey = (e) => {
            if (e.key === "ArrowRight") setCurrentIndex((i) => (i + 1) % selectedImages.length);
            else if (e.key === "ArrowLeft") setCurrentIndex((i) => (i - 1 + selectedImages.length) % selectedImages.length);
            else if (e.key === "Escape") closeModal();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [showModal, selectedImages.length]);

    useEffect(() => {
        if (showModal) return undefined;
        const timer = window.setInterval(() => {
            setActiveHero((i) => (i + 1) % heroSlides.length);
        }, 5000);
        return () => window.clearInterval(timer);
    }, [showModal]);

    // Scroll-trigger animations (snapshot refs)
    useEffect(() => {
        const snapshot = [...rowsRef.current];
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    entry.target.classList.toggle("visible", entry.isIntersecting);
                });
            },
            { threshold: 0.2 }
        );

        snapshot.forEach((row) => row && obs.observe(row));
        return () => {
            snapshot.forEach((row) => row && obs.unobserve(row));
            obs.disconnect();
        };
    }, []);

    return (
        <section id="gallery" className="gallery-event">
            <div className="gallery-header">
                <h2>
                    Triskelion: <span className="highlight">Frames of Timeless Treasures</span>
                </h2>
            </div>

            <div className="flipster-gallery" aria-label="Featured gallery carousel">
                <button className="flipster-nav flipster-prev" type="button" onClick={showPrevHero} aria-label="Previous slide">
                    <span aria-hidden="true">Prev</span>
                </button>

                <div className="flipster-stage">
                    {heroSlides.map((slide, index) => {
                        const position = getHeroPosition(index);
                        return (
                            <button
                                key={slide.src}
                                type="button"
                                className={`flipster-card ${position}`}
                                onClick={() => {
                                    setActiveHero(index);
                                    openModal(
                                        heroSlides.map((item) => ({ src: item.src, caption: item.title })),
                                        index
                                    );
                                }}
                                aria-label={`View ${slide.title}`}
                                aria-current={position === "active" ? "true" : undefined}
                                title="Click to view more photos"
                            >
                                <img src={slide.src} alt={slide.title} onError={(e) => fallback(e, index)} />
                                <span className="flipster-shine" aria-hidden="true" />
                            </button>
                        );
                    })}
                </div>

                <button className="flipster-nav flipster-next" type="button" onClick={showNextHero} aria-label="Next slide">
                    <span aria-hidden="true">Next</span>
                </button>

                <div className="flipster-copy">
                    <span className="flipster-kicker">Featured Moment</span>
                    <h1>{heroSlides[activeHero].title}</h1>
                    <p>{heroSlides[activeHero].text}</p>
                </div>

                <div className="flipster-dots" aria-label="Choose featured slide">
                    {heroSlides.map((slide, index) => (
                        <button
                            key={slide.src}
                            type="button"
                            className={index === activeHero ? "active" : ""}
                            onClick={() => setActiveHero(index)}
                            aria-label={`Go to ${slide.title}`}
                        />
                    ))}
                </div>
            </div>

            {/* Bootstrap carousel */}
            <div
                id="galleryCarousel"
                className="carousel slide carousel-fade"
                data-bs-ride="carousel"
                data-bs-interval="4000"
            >
                {/* Carousel Indicators */}
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" />
                    <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="1" aria-label="Slide 2" />
                    <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="2" aria-label="Slide 3" />
                    <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="3" aria-label="Slide 4" />
                    <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="4" aria-label="Slide 5" />
                </div>

                {/* Carousel Items */}
                <div className="carousel-inner">

                    {/* Slide 1 */}
                    <div className="carousel-item active">
                        <img
                            src={`${PUBLIC}/tgpEvents/57thAnniv.JPG`} 
                            alt="57th Founding Anniversary"
                            className="carousel-image d-block w-100"
                            onError={(e) => fallback(e, 0)}
                        />
                        <div className="carousel-caption">
                            <h1>57th Founding Anniversary of Tau Gamma Phi</h1>
                            <p>United in brotherhood and sisterhood under one banner — the Southern Alberta Regional Council.</p>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="carousel-item">
                        <img
                            src={`${PUBLIC}/tgpEvents/TGPAniv.jpg`}
                            alt="20th Anniversary"
                            className="carousel-image d-block w-100"
                            onError={(e) => fallback(e, 1)}
                        />
                        <div className="carousel-caption">
                            <h1>20 Years of Brotherhood, 20th Anniversary</h1>
                            <p>Tau Gamma Phi Southern Alberta marks two decades of unbreakable bonds and Triskelion pride.</p>
                            <p><em>"Here’s to the past, present, and future of our strong brotherhood!"</em></p>
                        </div>
                    </div>

                    {/* Slide 3 */}
                    <div className="carousel-item">
                        <img
                            src={`${PUBLIC}/tgpEvents/HWCleanup2023.jpg`}
                            alt="Highway Cleanup"
                            className="carousel-image d-block w-100"
                            onError={(e) => fallback(e, 2)}
                        />
                        <div className="carousel-caption">
                            <h1>Serving the Community: Highway Cleanup Drive 2023</h1>
                            <p>Southern Alberta Triskelions in action — proudly serving and keeping our roads clean.</p>
                            <p><em>“A Triskelion is always ready to serve.”</em></p>
                        </div>
                    </div>

                    {/* Slide 4 */}
                    <div className="carousel-item">
                        <img
                            src={`${PUBLIC}/tgpEvents/TGPOct4Aniv.jpg`}
                            alt="TGP Anniversary 2024"
                            className="carousel-image d-block w-100"
                            onError={(e) => fallback(e, 3)}
                        />
                        <div className="carousel-caption">
                            <h1>Bound by Purpose, United in Brotherhood</h1>
                            <p>Celebrating the unbreakable Triskelion spirit — strength, loyalty, and service!</p>
                        </div>
                    </div>

                    {/* Slide 5 */}
                    <div className="carousel-item">
                        <img
                            src={`${PUBLIC}/tgpEvents/2ndGeneralMeeting.jpg`}
                            alt="2nd General Meeting"
                            className="carousel-image d-block w-100"
                            onError={(e) => fallback(e, 4)}
                        />
                        <div className="carousel-caption">
                            <h1>2nd General Meeting & Easter Bonding</h1>
                            <p>Brotherhood, unity, and community — together as one Triskelion family!</p>
                        </div>
                    </div>
                </div>

                {/* Carousel Controls */}
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#galleryCarousel"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                </button>

                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#galleryCarousel"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                </button>
            </div>


            {/* Feature rows */}
            <div className="gallery-alt-rows">
                {[
                    {
                        img: featureImages.feature1,
                        title: "A Gift of Life: Triskelion Blood Donation",
                        text: (
                            <>
                                Brotherhood in action, Together as brothers, we proudly donated blood to support Canadian Blood Services and be part of Canada’s Lifeline. A single drop of blood can mean a lifetime for someone in need—because every donation is a gift of hope, a chance to save a life.
                                <br /><br />
                                True strength is not just measured by what we achieve, but by how we help others rise.
                                <br /><br />
                                We encourage all our brothers to step forward and support Canadian Blood Services. Be a hero today—donate blood, share life, and keep the lifeline flowing.
                            </>
                        ),
                    },
                    {
                        img: featureImages.feature2,
                        title: "Serving the Community: Annual Highway Cleanup Drive",
                        text: (
                            <>
                                Year after year, our Triskelion brothers and sisters come together for the Annual Highway Cleanup—proving that service is at the heart of true brotherhood.
                                <br /><br />
                                With unity, discipline, and compassion, we take pride in keeping our community clean and safe. This effort is more than just picking up litter—it’s about leaving a legacy of care, responsibility, and leadership for the next generation.
                                <br /><br />
                                Together, we show that when a Triskelion serves, we serve with all our heart. ‘A Triskelion is always ready to serve.’
                            </>
                        ),
                    },
                    {
                        img: featureImages.feature3,
                        title: "Empowering Communities: Volunteerism and Charity Work",
                        text: (
                            <>
                                The Triskelion brothers and sisters proudly stand at the forefront of community service—volunteering across countless events and causes. From cultural celebrations and local outreach programs to food drives, charity projects, and donation campaigns, we embody the true essence of servant leadership.
                                <br /><br />
                                Every effort we give, no matter how small, becomes a spark of hope for someone in need. Through unity, compassion, and discipline, we create a positive impact that goes beyond ourselves—uplifting families, strengthening communities, and inspiring others to serve.
                                <br /><br />
                                Service is not just an activity, it is our calling. Together, we continue to prove that the Triskelion way is to serve with a heart of gold and a spirit that never falters.
                            </>
                        ),
                    },
                    {
                        img: featureImages.feature4,
                        title: "Stronger Together: Celebrating Brotherhood & Sisterhood",
                        text: (
                            <>
                                Beyond service and outreach, the Triskelion brothers and sisters treasure the moments of togetherness—our fellowships, reunions, sports events, and celebrations.
                                <br /><br />
                                Gatherings like these remind us that the true strength of our fraternity and sorority lies not only in service, but in the bonds we share. Every smile, every story, and every memory strengthens our unity and keeps the Triskelion spirit alive
                                <br /><br />
                                Through laughter, teamwork, and unity, we continue to celebrate life’s milestones together—proving that once a Triskelion, always a Triskelion. The closeness we share today will remain timeless in our hearts.
                            </>
                        ),
                    },
                    {
                        img: featureImages.feature5,
                        title: "Brotherhood, Sisterhood, and Family: United in Life",
                        text: (
                            <>
                                We are not only brothers and sisters—we are a family. Every gathering reflects the values that make us who we are: unity, love, and belonging. Our celebrations go beyond fraternity and sorority ties, embracing our children, partners, friends, and the wider community who all play a part in our journey.
                                <br /><br />
                                These moments remind us that true strength comes from togetherness. Whether in service, fellowship, or celebration, we share laughter, joy, and memories that will last a lifetime.
                                <br /><br />
                                As Triskelions, we honor not only our bond as brothers and sisters, but also the family spirit that surrounds us—because in the end, it is family that completes our circle of life.
                            </>
                        ),
                    }
                ].map((gallery, index) => (
                    <div
                        key={index}
                        ref={(el) => (rowsRef.current[index] = el)}
                        className={`gallery-row ${index % 2 !== 0 ? "reverse" : ""}`}
                    >
                        <div className="gallery-img">
                            <img
                                src={gallery.img[0].src}
                                alt={gallery.title}
                                onClick={() => openModal(gallery.img)}
                                onError={(e) => fallback(e, 10 + index)}
                                title="Click to view more photos"
                            />
                        </div>
                        <div className="gallery-text">
                            <h3>{gallery.title}</h3>
                            <p>{gallery.text}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Modal */}
            {showModal && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>
                            ✖
                        </button>

                        <img
                            src={selectedImages[currentIndex].src}
                            alt={`Gallery ${currentIndex}`}
                            className="modal-img"
                            onError={(e) => fallback(e, 999)}
                        />
                        <p className="modal-caption">{selectedImages[currentIndex].caption}</p>

                        <div className="modal-controls">
                            <button
                                onClick={() =>
                                    setCurrentIndex((i) => (i - 1 + selectedImages.length) % selectedImages.length)
                                }
                            >
                                &lt; Prev
                            </button>
                            <button
                                onClick={() =>
                                    setCurrentIndex((i) => (i + 1) % selectedImages.length)
                                }
                            >
                                Next &gt;
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
